export const enum EStatusCartaConvite {
    ACEITA = "Aceita",
    DECLINOU = "Declínio",
    ENVIADA = "Enviada",
}

export const  enum EStatusVisitaTecnica {
    PARTICIPOU = "Participou",
    NAO_PARTICIPOU = "Não Participou",
}

export const  enum EStatusSolicitacaoEsclarecimentosTecnicos {
    ENVIADO = "Enviado",
    NAO_ENVIADO = "Não Enviado",
    DUVIDAS_CONSOLIDADAS = "Dúvidas Consolidadas",
    RESPOSTAS_ENVIADAS = "Respostas Enviadas",
    NAO_APLICAVEL = "Não Aplicável",
    DUVIDAS_COMPLEMENTARES = "Dúvidas Complementares",
}

export const  enum EStatusPropostaTecnica {
    RECEBIDO = "Recebido",
    RECUSADO = "Recusado",
}

export const  enum EStatusResultadoAvaliacaoComercial {
    APROVADO = "Aprovado",
}

export const  enum EStatusRodadaNegociacoes {
    CONCLUIDO = "Concluído",
    EM_ANDAMENTO = "Em Andamento",
    PENDENTE = "Pendente", //default
    NAO_PARTICIPANTE = "Não Participante",
}

export const enum EStatusEnvioComunicacaoContratada {
    ENVIADA = "Enviada",
    NAO_ENVIADA = "Não Enviada",
}

export const enum EStatusAprovacaoContratoTotvs {
    PENDENTE = "Pendente",
    APROVADO = "Aprovado",
    NAO_APLICAVEL = "Não Aplicável",
    EMITIDO = "Emitido",
    NAO_CRIADO = "Não Criado",
}

export const enum EStatusAprovacaoContrato {
    PENDENTE = "Pendente",
    ASSINATURA_CONCLUIDA = "Assinatura concluída",
    ASSINATURA_INTERROMPIDA = "Assinatura interrompida",
}